import React, { Component } from 'react';
import PropTypes from 'prop-types';
import anime from 'animejs';
import styles from './blobMaskMorpher.css';

class BlobMaskMorpher extends Component {
  constructor(props) {
    super(props);
    this.blobRef = React.createRef();
  }

  componentDidMount() {
    this.anime();
  }

  componentDidUpdate() {
    this.anime();
  }

  anime = () => {
    const shapes = [
      {
        paths: [
          {
            d:
              'M507.5,1022.68753 C683.122126,1022.68753 640.532735,832.357499 731.391954,696.601436 C785.253973,616.124235 1014,620.297629 1014,516.18753 C1014,373.959022 1047.81451,151.245689 953.413046,59.2465194 C862.147569,-29.6964639 645.003718,9.68752977 507.5,9.68752977 C395.463677,9.68752977 215.630737,49.578953 131.752762,111.164557 C6.20425949,203.345852 1,348.491627 1,516.18753 C1,695.193627 109.048458,729.698164 249.22557,819.7824 C328.102759,870.472496 406.773871,1022.68753 507.5,1022.68753 Z',
          },
          {
            d:
              'M507.5,1013.68753 C683.122126,1013.68753 640.532735,823.357499 731.391954,687.601436 C785.253973,607.124235 1014,611.297629 1014,507.18753 C1014,364.959022 875.808817,360.089077 781.407351,268.089908 C690.141874,179.146925 645.003718,0.687529771 507.5,0.687529771 C395.463677,0.687529771 446.149555,321.086376 362.27158,382.67198 C236.723077,474.853275 1,339.491627 1,507.18753 C1,686.193627 109.048458,720.698164 249.22557,810.7824 C328.102759,861.472496 406.773871,1013.68753 507.5,1013.68753 Z',
          },
          {
            d:
              'M428.5,890.504066 C604.122126,890.504066 561.532735,808.357499 652.391954,672.601436 C706.253973,592.124235 935,596.297629 935,492.18753 C935,349.959022 968.814512,127.245689 874.413046,35.2465194 C783.147569,-53.6964639 544.126457,60.6324162 406.62274,60.6324162 C294.586416,60.6324162 136.630737,25.578953 52.7527623,87.1645567 C-72.7957405,179.345852 67.2964188,356.58543 67.2964188,524.281332 C67.2964188,703.287429 30.0484582,705.698164 170.22557,795.7824 C249.102759,846.472496 327.773871,890.504066 428.5,890.504066 Z',
          },
        ],
      },
      {
        paths: [
          {
            d:
              'M381,672.473383 C482.047355,672.473383 533.60351,591.670589 601.797397,531.197109 C675.610108,465.740926 762,416.373135 762,307 C762,208.521562 663.120118,171.36181 601.797397,121.176954 C532.090857,64.1310082 492.942051,0.830498296 381,0.830498296 C254.910226,0.830498296 187.658346,48.3435482 118.310881,121.176954 C71.9302662,169.889019 0,222.669285 0,307 C0,417.888901 56.903402,497.680996 132.514635,563.227825 C200.381717,622.061307 281.468411,672.473383 381,672.473383 Z',
          },
          {
            d:
              'M381,762 C508.041805,762 621.613538,664.444498 690.837325,568.859012 C736.269522,506.125394 762,464.378685 762,381 C762,282.003116 640.445524,225.071191 578.546729,157.325975 C508.878001,81.076946 492.423606,0 381,0 C244.222495,0 163.20245,77.097254 96,185.338398 C59.8172297,243.616994 0,307.357015 0,381 C0,502.993683 105.687264,499.125484 194.881572,568.859012 C259.533836,619.40518 292.573194,762 381,762 Z',
          },
          {
            d:
              'M428.5,890.504066 C604.122126,890.504066 561.532735,808.357499 652.391954,672.601436 C706.253973,592.124235 935,596.297629 935,492.18753 C935,349.959022 968.814512,127.245689 874.413046,35.2465194 C783.147569,-53.6964639 544.126457,60.6324162 406.62274,60.6324162 C294.586416,60.6324162 136.630737,25.578953 52.7527623,87.1645567 C-72.7957405,179.345852 67.2964188,356.58543 67.2964188,524.281332 C67.2964188,703.287429 30.0484582,705.698164 170.22557,795.7824 C249.102759,846.472496 327.773871,890.504066 428.5,890.504066 Z',
          },
        ],
      },
    ];
    const index = Math.round(Math.random());

    const shape = shapes[index];

    anime({
      targets: this.blobRef.current,
      d: [
        { value: shape.paths[0].d },
        { value: shape.paths[1].d },
        { value: shape.paths[2].d },
      ],
      duration: this.props.duration,
      direction: 'alternate',
      autoplay: true,
      delay: anime.stagger(1000),
      easing: 'easeInOutQuad',
      elasticity: 900,
      loop: true,
      update: () => {
        const el = document.querySelector('.svg-mask');

        if (el !== null) {
          el.style.display = 'none';
          el.offsetWidth;
          el.style.display = 'block';
        }
      },
    });
  };

  render() {
    const { color, blobNum } = this.props;

    return (
      <>
        <svg
          fill={`${color}`}
          viewBox="0 0 1024 1024"
          style={this.style}
          className={styles.blob}>
          <clipPath
            id={`blobMask${blobNum}`}
            clipPathUnits="objectBoundingBox"
            transform={`scale(${1 / 1024}, ${1 / 1024})`}>
            <path
              ref={this.blobRef}
              d="M428.5,890.504066 C604.122126,890.504066 561.532735,808.357499 652.391954,672.601436 C706.253973,592.124235 935,596.297629 935,492.18753 C935,349.959022 968.814512,127.245689 874.413046,35.2465194 C783.147569,-53.6964639 544.126457,60.6324162 406.62274,60.6324162 C294.586416,60.6324162 136.630737,25.578953 52.7527623,87.1645567 C-72.7957405,179.345852 67.2964188,356.58543 67.2964188,524.281332 C67.2964188,703.287429 30.0484582,705.698164 170.22557,795.7824 C249.102759,846.472496 327.773871,890.504066 428.5,890.504066 Z"
            />
          </clipPath>
        </svg>
      </>
    );
  }
}

BlobMaskMorpher.defaultProps = {
  duration: 1000,
};

BlobMaskMorpher.propTypes = {
  color: PropTypes.string,
  duration: PropTypes.number,
  blobNum: PropTypes.number,
};

export default BlobMaskMorpher;
